module.exports = __webpack_public_path__ + "static/media/homepageMetaImage.0d27eb52.jpg";